<template>
    <div class="mt-4">
      <div class="strpied-tabled-with-hover">
          <div class="">
              <div class="row">
                  <div class="col-12 text-end mb-2">
                      <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#authForm">Add new login</button>
                  </div>
              </div>
          </div>
          <div class="table-full-width table-responsive">
              <table class="table table-hover table-striped">
                  <thead>
                      <tr>
                          <th>Authentication page</th>
                          <th>Action</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="list in pages" v-bind:key="list.ID">
                          <td>{{ list.method }} {{ list.page }}</td>
                          <td>
                            <button class="btn btn-link text-warning me-2" data-bs-toggle="modal" data-bs-target="#authForm" v-on:click="auth_id = list.id; refresh = Math.random()">
                              <i class="far fa-edit"></i>
                            </button>
                            <a href="javascript:void(0)" class="text-danger" title="Delete" v-on:click="deleteAuth(list.id)">
                                  <i class="fa fa-trash"></i>
                              </a>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
      <div class="modal fade" id="authForm" tabindex="-1">
        <div class="modal-dialog modal-xl">
           <div class="modal-content">
              <div class="modal-header">
                 <h5 class="modal-title" id="exampleModalLabel">{{ title }} authentication</h5>
                 <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeAuthForm" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <authForm v-on:callback="authCallback" :auth_id="auth_id" :key="refresh" />
              </div>
           </div>
        </div>
      </div>
    </div>
</template>
<script>
  import authForm from './authForm.vue'
  export default {
    components: {
      authForm
    },
    data () {
      return {
        pages: [],
        active: 0,
        project_id : this.$route.params.prod_id,
        org_id : this.$route.params.org_id,
        title: '',
        refresh: Math.random(),
        auth_id: 0
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        const me = this;
        this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/project/' + me.$route.params.prod_id + "/auth")
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.pages = r.data;
          }
        });
      },
      deleteAuth(id) {
        if (confirm("Are you sure you want to delete?")) {
          const me = this;
          this.$axios.delete(this.$server + 'organisation/' + me.$route.params.org_id + '/project/' + me.$route.params.prod_id + "/auth/" + id)
          .then(res => {
            var r = res.data;
            if (r.success) {
                me.init();
                me.$swal({
                    title: r.message
                });
            }
          });
        }
      },

      authCallback(res) {
        this.title = res;
        if (res == true) {
          document.getElementById("closeAuthForm").click();
          this.init();
        }
      }
    }
  }
</script>